import './scss/main.scss'

import $ from 'jquery';

import 'slick-carousel'

import "bootstrap";

$(document).scroll(function() {
	if($(document).scrollTop() >= 90){
		$("nav.fixed").addClass("active");
	}else{
		$("nav.fixed").removeClass("active");
	}
});

$('form[id="formContat"]').submit(function(){
	$('.message').removeClass("success error")

	var nome = $('#nome').val();
	var email = $('#email').val();
	var telefone = $('#whatsapp').val();
	var horario = $('#horario').val();
	var mensagem = $('#mensagem').val();

	if(email==""){
		$('#email').addClass("required")
	}else{
		$('#email').removeClass("required")
	}
	if(nome==""){
		$('#nome').addClass("required")
	}else{
		$('#nome').removeClass("required")
	}
	if(telefone==""){
		$('#whatsapp').addClass("required")
	}else{
		$('#whatsapp').removeClass("required")
	}
	
	if(email=="" || nome=="" || telefone==""){
		$(".message").html("*Preencha todos os campos!")
		$('.message').addClass("error")
	}else{
		var data = {
			email: email, 
			nome: nome,
			telefone: telefone,
			horario: horario,
			mensagem: mensagem,
			site: 'Suli Incorporadora'
		}
		$('form[id="formContat"] button').attr("disabled", true);
		$.ajax({
			type: "POST",
			url: "https://suliincorporadora.com.br/envio/envio.php",
			data: data,
			beforeSend : function(){
				$(".message").html("Enviando..")
			}
		}).done(function(resultado){
			if(resultado==1){
				$('.message').addClass("success")
				$('form[id="formContat"]').trigger("reset");
				$(".message").html("Sua mensagem foi enviada com sucesso, em breve entraremos em contato.")
			}else{
				$(".message").html("Ocorreu um erro ao tentar enviar sua mensagem. Por favor tente novamente mais tarde!")
			}
			$('form[id="formContat"] button').attr("disabled", false);
		});
	}
	return false;
});

$('.slidegrupo').slick({
	slidesToShow: 3,
	slidesToScroll: 1,
	prevArrow: $('.nav .prev'),
	nextArrow: $('.nav .next'),
	responsive: [{
		breakpoint: 1024,
		settings: {
			slidesToShow: 3
		}
		},{
		breakpoint: 600,
		settings: {
			slidesToShow: 2,
			adaptiveHeight: true
		}
		},{
		breakpoint: 480,
		settings: {
			slidesToShow: 1,
			adaptiveHeight: true
		}
	}]
});

$('.slides-1').on('beforeChange', function(event, slick, currentSlide, nextSlide){
	$('.slick-slide').removeClass("animeExit")
	$('.slick-slide[data-slick-index="'+currentSlide+'"]').addClass("animeExit");
});

$('.slides-2').slick({
	slidesToShow: 2,
	slidesToScroll: 1,
	centerMode: false,
	prevArrow: $('.slide2 .prev'),
	nextArrow: $('.slide2 .next'),
	responsive: [{
		breakpoint: 1024,
		settings: {
			slidesToShow: 1
		}
		},{
		breakpoint: 600,
		settings: {
			slidesToShow: 1
		}
		},{
		breakpoint: 480,
		settings: {
			slidesToShow: 1
		}
	}]
});

$(document).on('click', 'a.row-scroll', function (event) {
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top
    }, 1000);
});

$(".button-menu").click(function(){
	$(".menu-mobile").addClass("active");
});

$(".button-menu-close").click(function(){
	$(".menu-mobile").removeClass("active");
});

$(".menu-mobile li a").click(function(){
	$(".menu-mobile").removeClass("active");
});

// AJAX PAGINATION
$('.posts').on('click', 'a.page-numbers', function(e){
	e.preventDefault();
	var properties_wrapper = $('.properties-wrapper');
	var link = jQuery(this).attr('href');

	// opacity and disable on click
	properties_wrapper.css({
	   'opacity' : '0.5',
	   'pointer-events' : 'none'
	});

	$.get(link, function(data, status) {
		//console.log(status);

		var properties = jQuery(".properties-wrapper .row", data);
		properties_wrapper.html(properties); // load properties
		// scroll in top of wrapper section
		$('html,body').animate({ 
				scrollTop: properties_wrapper.offset().top - 150
			}, 'slow'
		);

		// opacity and disable on click
		properties_wrapper.css({
		   'opacity' : '1',
		   'pointer-events' : 'all'
		});
	});

	//pagination.load(link+' .ic-pagination ul');
	// update url
	//window.history.pushState('obj', 'client', link);
	//return false;

});